import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { AjsResponse, wrapAjs } from "../ajs-response";

/**
 * UserPreferencesApiService (Angular 18).
 *
 * Replaces apps/b2b-ui/common/services/api/userPreferencesApi/userPreferencesApi.service.js.
 *
 * Legacy uses ApiVersionFactory to rewrite `/v1/` → `/v2/`. Hardcoded here.
 * The body shape (preferences/viewId/userId/app) is preserved 1:1.
 */
const USER_PREFERENCES_BASE_V2 = "/v2/api/user/preferences/b2b";

interface UserPreferencesPayload {
  preferences?: unknown[];
}

function buildBody(
  id: string | number,
  props: UserPreferencesPayload,
  userId: string | number,
) {
  return {
    preferences: props.preferences ?? [],
    viewId: id,
    userId,
    app: "b2b",
  };
}

@Injectable({ providedIn: "root" })
export class UserPreferencesApiService {
  private readonly http = inject(HttpClient);

  get(id: string | number): Promise<AjsResponse<unknown>> {
    return wrapAjs(this.http.get<unknown>(`${USER_PREFERENCES_BASE_V2}/${id}`));
  }

  create(
    id: string | number,
    props: UserPreferencesPayload,
    userId: string | number,
  ): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.post<unknown>(
        `${USER_PREFERENCES_BASE_V2}/${id}`,
        buildBody(id, props, userId),
      ),
    );
  }

  update(
    id: string | number,
    props: UserPreferencesPayload,
    userId: string | number,
  ): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.put<unknown>(
        `${USER_PREFERENCES_BASE_V2}/${id}`,
        buildBody(id, props, userId),
      ),
    );
  }
}
